import { Vector3 } from "three";

export interface ModelConfig {
  id: string;
  label: string;
  description: string;
  category: string;
  camera: {
    position: Vector3;
    target: Vector3;
    focusDistance: number;
  };
  thumbnail?: string;
  modelPath: string;
  realSize: {
    width: number; // 真实宽度（cm）
    height: number; // 真实高度（cm）
    depth: number; // 真实深度（cm）
    scale: number; // 3D模型相对于真实尺寸的缩放比例
  };
}

export const modelConfigs: ModelConfig[] = [
  {
    id: "mug",
    label: "Coffee Mug",
    description: "Classic ceramic coffee mug",
    category: "drinkware",
    camera: {
      position: new Vector3(0.3, 0.3, 0.5),
      target: new Vector3(0, 0, 0),
      focusDistance: 0.15,
    },
    modelPath: "/assets/models/mug.glb",
    realSize: {
      width: 8, // 8cm 宽度
      height: 10, // 10cm 高度
      depth: 8, // 8cm 深度
      scale: 1.0, // 3D模型缩放比例
    },
  },
  {
    id: "bass",
    label: "Bass Guitar",
    description: "Electric bass guitar",
    category: "instruments",
    camera: {
      position: new Vector3(1.0, 1.0, 1.5),
      target: new Vector3(0, 0, 0),
      focusDistance: 0.4,
    },
    modelPath: "/assets/models/bass.glb",
    realSize: {
      width: 35, // 35cm 宽度
      height: 120, // 120cm 高度
      depth: 4, // 4cm 深度
      scale: 1.0, // 3D模型缩放比例
    },
  },
  {
    id: "lighter",
    label: "Zippo Lighter",
    description: "Classic metal lighter",
    category: "accessories",
    camera: {
      position: new Vector3(2, 2, 3),
      target: new Vector3(0, 0, 0),
      focusDistance: 0.8,
    },
    modelPath: "/assets/models/lighter.glb",
    realSize: {
      width: 2.5, // 2.5cm 宽度
      height: 8, // 8cm 高度
      depth: 1.5, // 1.5cm 深度
      scale: 1.0, // 3D模型缩放比例
    },
  },
];

export const getModelConfig = (id: string): ModelConfig | undefined => {
  return modelConfigs.find((config) => config.id === id);
};

export const getModelsByCategory = (category: string): ModelConfig[] => {
  return modelConfigs.filter((config) => config.category === category);
};

export const getAllCategories = (): string[] => {
  return Array.from(new Set(modelConfigs.map((config) => config.category)));
};
